<template>
  <v-app>
    <v-progress-linear v-if="progress"
                       indeterminate
    ></v-progress-linear>
    <router-view />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'progress'
    ]),
  },
  data: () => ({
    //
  }),
};
</script>
